import * as React from 'react'

import { Checkbox } from '@/components/ui'
import type { CheckboxProps, CheckedState } from '@/components/ui/Checkbox'
import { cn, slugify } from '@/utils'

export interface CheckboxFieldProps extends CheckboxProps {
  label?: string | React.ReactNode
  error?: string | null
  helpText?: string
  labelClassName?: string
}

const CheckboxField = React.forwardRef<HTMLInputElement, CheckboxFieldProps>(
  (
    { id, label, className, labelClassName, error, helpText, ...props },
    ref,
  ) => {
    const _id = id
      ? id
      : `checkbox_${typeof label === 'string' ? slugify(label) : ''}_${crypto.randomUUID()}`

    return (
      <div className={cn('space-y-1.5', className)}>
        <div className="flex items-center space-x-2">
          <Checkbox id={_id} ref={ref} {...props} />
          <div className="grid gap-1.5 leading-none">
            <label
              htmlFor={_id}
              className={cn(
                'text-sm text-muted-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer',
                labelClassName,
              )}
            >
              {label}
            </label>
          </div>
        </div>
        {error && <p className="text-xs font-semibold text-red-500">{error}</p>}
        {helpText && (
          <p className="text-xs text-muted-foreground leading-relaxed">
            {helpText}
          </p>
        )}
      </div>
    )
  },
)
CheckboxField.displayName = 'CheckboxField'

export { CheckboxField }
export type { CheckedState }
